global.version = "1.0.2";


global.menu = [
  { title: "เมนูหลัก" },
  { name: "แดชบอร์ด", icon: "\uf0ac", link: "/dashboard", role: "dashboard" },

  { title: "ข้อมูลผู้ใช้งาน" },
  { name: "เจ้าของแปลง", icon: "\uf007", link: "/land-owners", role: "land-owners" },
  { name: "พนักงาน", icon: "\uf508", link: "/users", role: "users" },
  { name: "ผู้รับเหมา", icon: "\uf82c", link: "/contractors", role: "contractors" },
  { name: "สิทธิ์การใช้งาน", icon: "\uf023", link: "/roles", role: "roles" },
  
  { title: "กิจกรรมส่งเสริม" }, 
  { name: "ข้อมูลแปลงอ้อย", icon: "\uf06c", link: "/plot-informations", role: "plot-informations" },
  { name: "กิจกรรม", icon: "\uf06c", link: "/activity-trakings", type: "activity-trakings", role: "activity-trakings" },
  
  { title: "การตั้งค่า" },
  { name: "ตั้งค่าระบบ", icon: "\uf013", link: "/system-settings", role: "system-settings" },
  { name: "รายการกิจกรรม", icon: "\uf78a", link: "/activitys", role: "activitys" },
  { name: "ฟิลด์", icon: "\uf022", link: "/fields", role: "fields" },
  { name: "อุปสรรคในแปลง", icon: "\uf05e", link: "/drawbacks", role: "drawbacks" },
  { name: "ประเภทอ้อย/สายพันธุ์", icon: "\uf7aa", link: "/cane-types", role: "cane-types" },
  { name: "ประเภทการซื้อ", icon: "\uf290", link: "/purchase-types", role: "purchase-types" },
  { name: "ประเภทการตัด", icon: "\uf6b2", link: "/cutting-types", role: "cutting-types" },
  { name: "ประเภทการไถ", icon: "\uf722", link: "/plowing-types", role: "plowing-types" },
  { name: "ประเภทการใส่ปุ๋ย", icon: "\uf4c1", link: "/fertilizing-types", role: "fertilizing-types" },
  { name: "ฉีดยากำจัดวัชพืช", icon: "\uf5bd", link: "/herbicide-types", role: "herbicide-types" },
  { name: "การเข้าตัด", icon: "\uf0c4", link: "/cutting-entry-types", role: "cutting-entry-types" },
  { name: "การส่งอ้อย", icon: "\uf48b", link: "/cane-delivery-types", role: "cane-delivery-types" },
  { name: "เลขโควต้า", icon: "\uf02b", link: "/quota-numbers", role: "quota-numbers" },
  { name: "ประเภทรถบรรทุก", icon: "\uf0d1", link: "/truck-types", role: "truck-types" },
  { name: "สถานะแปลง", icon: "\uf1fe", link: "/plot-status", role: "plot-status" },
  { name: "ประเภทแปลง", icon: "\uf57d", link: "/plot-types", role: "plot-types" },
  { name: "ประเภทดิน", icon: "\uf4d8", link: "/soil-types", role: "soil-types" },
  { name: "กลุ่มรถ", icon: "\uf48b", link: "/group-cars", role: "group-cars" },
  
  { title: "รายงาน" },
  { name: "Trip Sheet", icon: "\uf48b", link: "/trip-sheets-report", role: "trip-sheets-report" },
  { name: "การบันทึกข้อมูลประเมินผลผลิตอ้อย", icon: "\uf48b", link: "/yield-eval-report", role: "yield-eval-report" },
  { name: "การตัดอ้อย", icon: "\uf48b", link: "/cutting-report", role: "cutting-report" },
  { name: "การผู้รับเหมา", icon: "\uf48b", link: "/contractor-report", role: "contractor-report" },
  { name: "ค่าตัดคีบ-อ้อยตามแปลง", icon: "\uf48b", link: "/cut-load-cost-report", role: "cut-load-cost-report" },
  { name: "ตันต่อแปลง", icon: "\uf48b", link: "/tons-plot-report", role: "tons-plot-report" },
  { name: "performance ของผู้คุมตัด", icon: "\uf48b", link: "/supervisor-perf-report", role: "supervisor-perf-report" },
  { name: "รายงานกิจกรรมผู้รับเหมา", icon: "\uf48b", link: "/contractor-activities-report", role: "contractor-activities-report" },
  { name: "รายงานข้อมูลแปลงอ้อย", icon: "\uf48b", link: "/plot-data-report", role: "plot-data-report" },
  { name: "รายงานคิวช่าง", icon: "\uf48b", link: "/technician-queue-report", role: "technician-queue-report" },

  { title: "อื่นๆ" },
  { name: "อัพโหลด ดาวน์โหลด", icon: "", link: "/kmz", role: "kmz" },
  { name: "ประวัติการเปลี่ยนแปลง (Log)", icon: "", link: "/audit-logs", role: "audit-logs" },
];

global.permission_th = {
"dashboard": "แดชบอร์ด",
"land-owners": "เจ้าของแปลง",
"users": "พนักงาน",
"contractors": "ผู้รับเหมา",
"roles": "สิทธิ์การใช้งาน",
"activity-trakings": "กิจกรรม",
"plot-informations": "ข้อมูลแปลงอ้อย",
"system-settings": "ตั้งค่าระบบ",
"activitys": "รายการกิจกรรม",
"fields": "ฟิลด์",
"drawbacks": "อุปสรรคในแปลง",
"cane-types": "ประเภทอ้อย/สายพันธุ์",
"purchase-types": "ประเภทการซื้อ",
"cutting-types": "ประเภทการตัด",
"plowing-types": "ประเภทการไถ",
"fertilizing-types": "ประเภทการใส่ปุ๋ย",
"herbicide-types": "ฉีดยากำจัดวัชพืช",
"cutting-entry-types": "การเข้าตัด",
"cane-delivery-types": "การส่งอ้อย",
"quota-numbers": "เลขโควต้า",
"truck-types": "ประเภทรถบรรทุก",
"plot-status": "สถานะแปลง",
"plot-types": "ประเภทแปลง",
"soil-types": "ประเภทดิน",
"group-cars": "กลุ่มรถ",
"trip-sheets-report": "รายงาน Trip Sheet",
"yield-eval-report": "รายงานการบันทึกข้อมูลประเมินผลผลิตอ้อย",
"cutting-report": "รายงานการตัดอ้อย",
"contractor-report": "รายงานการผู้รับเหมา",
"cut-load-cost-report": "รายงานค่าตัดคีบ-อ้อยตามแปลง",
"tons-plot-report": "รายงานตันต่อแปลง",
"supervisor-perf-report": "รายงาน performance ของผู้คุมตัด",
"contractor-activities-report": "รายงานกิจกรรมผู้รับเหมา",
"plot-data-report": "รายงานข้อมูลแปลงอ้อย",
"technician-queue-report": "รายงานคิวช่าง",
"audit-logs": "ประวัติการเปลี่ยนแปลง (Log)",
"cost": "ค่าใช้จ่าย และ ราคา"
}

global.permission = [

"dashboard.read",
"land-owners.read",
"users.read",
"contractors.read",
"roles.read",
"activity-trakings.read",
"plot-informations.read",
"system-settings.read",
"activitys.read",
"fields.read",
"drawbacks.read",
"cane-types.read",
"purchase-types.read",
"cutting-types.read",
"plowing-types.read",
"fertilizing-types.read",
"herbicide-types.read",
"cutting-entry-types.read",
"cane-delivery-types.read",
"quota-numbers.read",
"truck-types.read",
"plot-status.read",
"plot-types.read",
"soil-types.read",
"group-cars.read",
"trip-sheets-report.read",
"yield-eval-report.read",
"cutting-report.read",
"contractor-report.read",
"cut-load-cost-report.read",
"tons-plot-report.read",
"supervisor-perf-report.read",
"contractor-activities-report.read",
"plot-data-report.read",
"technician-queue-report.read",
"audit-logs.read",
"cost.read",

"dashboard.create",
"land-owners.create",
"users.create",
"contractors.create",
"roles.create",
"activity-trakings.create",
"plot-informations.create",
"system-settings.create",
"activitys.create",
"fields.create",
"drawbacks.create",
"cane-types.create",
"purchase-types.create",
"cutting-types.create",
"plowing-types.create",
"fertilizing-types.create",
"herbicide-types.create",
"cutting-entry-types.create",
"cane-delivery-types.create",
"quota-numbers.create",
"truck-types.create",
"plot-status.create",
"plot-types.create",
"soil-types.create",
"group-cars.create",
"trip-sheets-report.create",
"yield-eval-report.create",
"cutting-report.create",
"contractor-report.create",
"cut-load-cost-report.create",
"tons-plot-report.create",
"supervisor-perf-report.create",
"contractor-activities-report.create",
"plot-data-report.create",
"technician-queue-report.create",
"audit-logs.create",
"cost.create",

"dashboard.update",
"land-owners.update",
"users.update",
"contractors.update",
"roles.update",
"activity-trakings.update",
"plot-informations.update",
"system-settings.update",
"activitys.update",
"fields.update",
"drawbacks.update",
"cane-types.update",
"purchase-types.update",
"cutting-types.update",
"plowing-types.update",
"fertilizing-types.update",
"herbicide-types.update",
"cutting-entry-types.update",
"cane-delivery-types.update",
"quota-numbers.update",
"truck-types.update",
"plot-status.update",
"plot-types.update",
"soil-types.update",
"group-cars.update",
"trip-sheets-report.update",
"yield-eval-report.update",
"cutting-report.update",
"contractor-report.update",
"cut-load-cost-report.update",
"tons-plot-report.update",
"supervisor-perf-report.update",
"contractor-activities-report.update",
"plot-data-report.update",
"technician-queue-report.update",
"audit-logs.update",
"cost.update",

"dashboard.delete",
"land-owners.delete",
"users.delete",
"contractors.delete",
"roles.delete",
"activity-trakings.delete",
"plot-informations.delete",
"system-settings.delete",
"activitys.delete",
"fields.delete",
"drawbacks.delete",
"cane-types.delete",
"purchase-types.delete",
"cutting-types.delete",
"plowing-types.delete",
"fertilizing-types.delete",
"herbicide-types.delete",
"cutting-entry-types.delete",
"cane-delivery-types.delete",
"quota-numbers.delete",
"truck-types.delete",
"plot-status.delete",
"plot-types.delete",
"soil-types.delete",
"group-cars.delete",
"trip-sheets-report.delete",
"yield-eval-report.delete",
"cutting-report.delete",
"contractor-report.delete",
"cut-load-cost-report.delete",
"tons-plot-report.delete",
"supervisor-perf-report.delete",
"contractor-activities-report.delete",
"plot-data-report.delete",
"technician-queue-report.delete",
"audit-logs.delete",
"cost.delete",

];

global.required_fields = ["plot_number", "activity_date"];
global.field_groups = [
  { type: "required", label: "ฟิลด์บังคับ" },
  { type: "image", label: "รูปภาพ" },
  { type: "video", label: "วิดีโอ" },
  { type: "date", label: "วันที่" },
  { type: "text", label: "ข้อความ" },
  { type: "number", label: "ตัวเลข" },
  { type: "select", label: "ตัวเลือก" },
  { type: "rate", label: "คะแนน" },
  { type: "checkbox", label: "เช็ค" },
  { type: "textarea", label: "ข้อความหลายบรรทัด" },
];